import React from "react";

import RootElementWrapper from "./src/RootElementWrapper";

export const wrapRootElement = ({ element, ...restProps }, pluginOptions) => {
  return (
    <RootElementWrapper {...restProps} pluginOptions={pluginOptions}>
      {element}
    </RootElementWrapper>
  );
};
